module.exports = __webpack_public_path__ + "img/93.10.pH.96d91d18.png";